export default "__VITE_ASSET__VRilLp6q__"